module.exports = new __parcel__URL__("connected_earth_biodiversity.6d153b04.png").toString();